// eslint-disable-next-line no-restricted-imports
import { useRouter as useNextRouter } from 'next/navigation';

export function useRouter() {
	const router = useNextRouter();

	return {
		...router,
		push: (href: string, options?: Parameters<typeof router.push>[1]) => router.push(href, { scroll: false, ...options }),
		replace: (href: string, options?: Parameters<typeof router.replace>[1]) => router.replace(href, { scroll: false, ...options })
	};
}